import React, { useEffect, useContext } from 'react'
import { Grid, Typography, Container, useMediaQuery, Box, CssBaseline } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import UploadForm from '../components/UploadForm';
import { useTheme, styled } from '@mui/material/styles';




const DataUpload = () => {
   
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div style={{ background: theme.palette.background.default, height: '100vh' }}>

            <CssBaseline />
            <Navbar />
            <Grid container style={{ height: 'calc(100vh - 64px)' }}> {/* Adjusted height */}
                {!isSmallScreen && (
                    <Grid item xs={2} style={{ height: '100%' }}>
                        <Sidebar />
                    </Grid>
                )}
                <Grid item xs={12} sm={10} style={{ height: '100%', overflowY: 'auto', padding: '10px' }}>
                <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    height="100%"
  >
    <UploadForm />
  </Box>
                </Grid>

            </Grid>

        </div>
    );

}

export default DataUpload